<div class="row productLabelFormPage">
  <div class="mainContent">

    <div class="row">
      <div class="col-12 header margin-l0">
        <h3 class="py-2">
          Mini-Bulk Label Order Form
        </h3>
      </div>
    </div>
    <div class="OrderReleaseTop">

      <div class="row">
        <div class="col-md-3 material-select withBordr productLabelAccountName">
          <ng-select name="ddlShipTo"
                     [items]="shipToData"
                     class="custom-select-grower grower-add-drop"
                     [virtualScroll]="true"
                     bindLabel="accountNumber"
                     bindValue="accountNumber"
                     placeholder="Account #:*"
                     [(ngModel)]="formdata.accountNumber"
                     [loading]="shipToDataLoading"
                     (change)="onAccountInputChange($event)"
                     [closeOnSelect]="true"
                     data-testid="ddl-ship-to-search"
                     [disabled]="readOnlyAccess"
                     [searchFn]="accountSearchFn">
            <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
              <div class="dropdown-template" [attr.data-testid]="'ddl-shipto-return-option_'+index">
                <div class="row">
                  <div class="col-md-12">
                    <h4 class="name greenColor" [ngOptionHighlight]="search">
                      {{item.accountName}}
                    </h4>
                    <p class="address" [ngOptionHighlight]="search">
                      {{item.address1}},  {{item.city}}, {{item.state}} - {{item.zipCode}}
                    </p>
                    <p class="phoneNo" [ngOptionHighlight]="search">
                      {{item.primaryPhoneNumber}}
                    </p>
                    <p class="grower-nos">
                      <span class="grower-gln" [ngOptionHighlight]="search">
                        Account #: {{item.accountNumber}}
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </ng-template>
          </ng-select>
        </div>

        <div class="col-md-3">
          <mat-form-field class="wide100">
            <mat-label>Account:</mat-label>
            <input matInput type="text" name="account" class="pb-1"
                   readonly
                   [(ngModel)]="formdata.accountName"
                   autocomplete="off">
          </mat-form-field>
        </div>
        <div class="col-md-3">
          <mat-form-field class="wide100">
            <mat-label>Attn:</mat-label>
            <input matInput type="text" name="attn" class="pb-1"
                   maxlength="100"
                   [(ngModel)]="formdata.attn"
                   [readonly]="readOnlyAccess"
                   autocomplete="off">
          </mat-form-field>
        </div>
        <div class="col-md-3">
          <mat-form-field class="wide100">
            <mat-label>Address:*</mat-label>
            <textarea style="resize:none;height:20px;overflow: hidden;margin-bottom: 8px;" matInput rows="3"
                      name="address"
                      [maxLength]="250"
                      [readonly]="readOnlyAccess"
                      [(ngModel)]="formdata.address"></textarea>
          </mat-form-field>
          <div class="row" style="margin-top: -10px;">
            <div class="col-md-4">
              <mat-form-field class="wide100">
                <mat-label>City:*</mat-label>
                <input matInput type="text"
                       name="city"
                       class="pb-1"
                       maxlength="25"
                       [readonly]="readOnlyAccess"
                       [(ngModel)]="formdata.city">
              </mat-form-field>
            </div>

            <div class="col-md-4">
              <mat-form-field class="wide100">
                <mat-label>State:*</mat-label>
                <input matInput type="text"
                       name="state" class="pb-1"
                       [(ngModel)]="formdata.state"
                       [readonly]="readOnlyAccess"
                       maxlength="25">
              </mat-form-field>
            </div>

            <div class="col-md-4">
              <mat-form-field class="wide100">
                <mat-label>ZIP Code:*</mat-label>
                <input matInput type="text"
                       name="postalCode"
                       class="pb-1"
                       [(ngModel)]="formdata.zipCode"
                       (keypress)="keyPressNumbers($event)"
                       [readonly]="readOnlyAccess"
                       maxlength="12">
              </mat-form-field>
            </div>
          </div>
        </div>

      </div>


      <div class="row"  style="margin-top: -8px;">
        <div class="col-md-3">
          <!--<mat-form-field class="wide100">
            <input matInput type="text" name="Date" class="pb-1"
                   placeholder="Date Ordered:"
                   readonly
                   [(ngModel)]="formdata.orderedDate"
                   autocomplete="off">
            <mat-icon matSuffix>calendar_today</mat-icon>
          </mat-form-field>-->
          <mat-form-field class="wide100">
            <mat-label>Date Ordered:</mat-label>
            <input matInput type="text" name="Date" class="pb-1"
                   readonly
                   [(ngModel)]="formdata.orderedDate"
                   autocomplete="off">
            <mat-datepicker-toggle matSuffix [for]="picker" disabled></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>

        </div>
        <div class="col-md-3">
          <mat-form-field class="wide100">
            <mat-label>Ordered By:*</mat-label>
            <input matInput type="text"
                   name="orderedBy"
                   class="pb-1"
                   maxlength="40"
                   [(ngModel)]="formdata.orderedBy"
                   [readonly]="readOnlyAccess"
                   autocomplete="off">
          </mat-form-field>
        </div>
        <div class="col-md-3 purchaseOrder">
          <mat-form-field class="wide100" [ngClass]="{valid : (isNotValid ==false)}">
            <mat-label>Email for ship confirmation:*</mat-label>
            <input matInput type="text" name="accountEmail" maxlength="100"
                   class="pb-1"
                   placeholder="(Separate multiple email by a semi-colon)"
                   [readonly]="readOnlyAccess"
                   [(ngModel)]="formdata.email"
                   [pattern]="emailPattern"
                   (blur)="validateEmail()"
                   [errorStateMatcher]="matcher"
                   data-testid="ddl-cpp-email">
            <mat-error *ngIf="isNotValid">
              This is invalid e-mail address(s). Separate multiple email addresses by a semi-colon.
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-md-3  deliveryNotes cppDeliveryInstructionsUpdatedBy">
          <mat-form-field class="wide100">
            <mat-label>Winfield United Account Manager:</mat-label>
            <input matInput type="text" name="accountManager" class="pb-1"
                   [readonly]="readOnlyAccess"
                   maxlength="40"
                   [(ngModel)]="formdata.accountManager"
                   autocomplete="off">
          </mat-form-field>
        </div>
      </div>
      <div class="row" style="margin-top: -5px;">

        <div class="col-md-3 material-select productLabelAccountName">
          <div class="row d-flex align-items-center">
            <label class="col-5 mb-0">Overnight Delivery:*</label>
            <ng-select name="ddldeliveryType"
                       [items]="ddldeliveryList"
                       [(ngModel)]="formdata.overNightDelivery"
                       [clearable]="false"
                       [readonly]="readOnlyAccess"
                       [searchable]="false"
                       class="custom-select-grower grower-add-drop col-3"
                       [virtualScroll]="true"
                       bindLabel="value"
                       bindValue="id"
                       [closeOnSelect]="true"
                       [disabled]="readOnlyAccess"
                       data-testid="ddl-delivery-type" style="margin-top: -20px;">
            </ng-select>
          </div>

        </div>
      </div>

    </div>
    <div class="productsection d-flex align-items-center" [ngStyle]="!readOnlyAccess && selectedCount > 0 ? {'visibility': 'visible'} : {'visibility': 'hidden'}">
      <div class="col-md-2 d-flex align-items-center">
        <mat-checkbox #Allcheck class="custom-checkbox select-all-check mt-0"
                      [checked]="dataSource.length > 0 && (selectedCount > 0) && (selectedCount == dataSource.length)"
                      [indeterminate]="dataSource.length > 0 && (selectedCount > 0) && (selectedCount < dataSource.length)"
                      [style.display]="readOnlyAccess ? 'none' : ''"
                      (change)="enableAllCheckBoxes(Allcheck._checked);"
                      matTooltip="Select All Items" [matTooltipPosition]="'above'"
                      data-testid="ddl-select-all-product"></mat-checkbox>

        <div class="product-tools-outer" *ngIf="showTabs">
          <div class="product-tools-tab" appClickOutside (clickOutside)="tabNode=''">

            <div class="tab-bar margin-l15 col-md-10">
              <ul>
                <li (click)="tabNode='delete'" class="seperator" matTooltip="Delete Items from Order" [matTooltipPosition]="'above'">
                  <i class="icon-ico-trash"></i>
                </li>
              </ul>
            </div>

            <div class="tab-content">
              <div *ngIf="tabNode==='delete'" class="delete-product">
                <div class="tab-content-heading">
                  Product Label Order Delete
                </div>
                <div class="tab-content-detail">
                  <p>Are you sure you want to delete <span> {{selectedCount}} </span> selected Items(s)?</p>
                  <div class="btn-area">
                    <button mat-raised-button class="btns normal-large-btn" color="primary" (click)="deleteSelectedItems(true)">Yes</button>
                    <button mat-raised-button class="btns normal-large-btn" color="primary" (click)="deleteSelectedItems(false)">No</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="tableOuterContainer">
      <table mat-table [dataSource]="dataSource" class="productTable matTables">
        <!-- Checkbox Column -->
        <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef>  </th>
          <td mat-cell *matCellDef="let element">
            <mat-checkbox #SingleCheck class="custom-checkbox"
                          [style.display]="'contents'"
                          [disabled]="readOnlyAccess"
                          (change)="enableCheckBoxSingle(SingleCheck._checked)"
                          [(ngModel)]="element.selected"
                          [attr.data-testid]="'ddl-specific-check_'+i"></mat-checkbox>
          </td>
          <td mat-footer-cell *matFooterCellDef> </td>
        </ng-container>

        <ng-container matColumnDef="product">
          <th mat-header-cell *matHeaderCellDef> Product <span class="productHeaderNote">NOTE: Watch EPA Numbers</span> </th>
          <td mat-cell *matCellDef="let element"> <span>{{ element.productName }} </span></td>
          <td mat-footer-cell *matFooterCellDef class="padding-l0 padding-r0">
            <div class="row">
              <div class="col-4 material-select withBordr">
                <ng-select name="ddlProductlabelItem"
                           [items]="productLabelItemList"
                           class="custom-select-grower grower-add-drop productLabelDropdown"
                           [virtualScroll]="true"
                           bindLabel="productName"
                           [disabled]="readOnlyAccess"
                           bindValue="itemId"
                           [placeholder]="selectedItemId ? '' : 'Select Product'"
                           [(ngModel)]="selectedItemId"
                           [closeOnSelect]="true"
                           [searchFn]="filterSearchFn"
                           (change)="onItemSelected()">
                  <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                    <div class="dropdown-template">
                      <div class="row">
                        <div class="col-md-10">
                          <p class="name greenColor" [ngOptionHighlight]="search">{{item.productName}}</p>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                </ng-select>

              </div>
              <div class="col-4 d-flex align-items-center newInputText">
                <span>
                  <a href="Javascript:void(0);" (click)="showAddNewItemInput()">
                    Enter product name not in dropdown
                  </a>
                </span>
              </div>
            </div>
          </td>


        </ng-container>

        <ng-container matColumnDef="labelQty">
          <th mat-header-cell *matHeaderCellDef> Label Qty </th>
          <td mat-cell *matCellDef="let element">
            <div>
              <button (click)="geuValueChange('decrease',element);" class="plus-minus-btn minusBtn" [attr.data-testid]="'decrease-' + element.productName"> - </button>
              <input [readonly]="readOnlyAccess" type="text" class="geu-txt decimal-txt unitsText largeTableTxt" (keyup)="quantityTextChange(element)" [(ngModel)]="element.quantity" maxlength="10" appNumbersOnly [ngClass]="{'invalid-txt': (element.quantity<=0 || element.quantity=='')}" [attr.data-testid]="'txt-specific-qty_'+i" />
              <button (click)="geuValueChange('increase',element)" class="plus-minus-btn plusBtn" [attr.data-testid]="'increase-' + element.productName"> + </button>
            </div>
          </td>
          <td mat-footer-cell *matFooterCellDef>  </td>


        </ng-container>

        <!--Enter product Name Row-->

        <ng-container matColumnDef="disclaimerNew">
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>
        <ng-container matColumnDef="disclaimer">
          <!--<td  mat-footer-cell *matFooterCellDef colspan="1"></td>-->
          <td mat-footer-cell *matFooterCellDef colspan="2">
            <div class="row">
              <div class="col-4 px-0" style="margin-top:20px">
                <mat-form-field>
                  <mat-label *ngIf="newItemName <= 0" floatLabel="auto">Enter Product Name</mat-label>
                  <input matInput [(ngModel)]="newItemName" maxlength="50" />
                </mat-form-field>

              </div>
              <div class="col-1 d-flex align-items-center enterInputText">
                <span> <a href="Javascript:void(0);" (click)="saveNewItem()">Save</a></span>
              </div>
              <div class="col-7 d-flex" style="margin-top:8px">
                <p class="productHeaderNote" style="color: #E84F4B;">{{warningMessage}}</p>
              </div>

            </div>
          </td>

        </ng-container>


        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

        <tr mat-footer-row *matFooterRowDef="displayedColumns;sticky:true;" class="example-first-footer-row"></tr>
        <tr mat-footer-row *matFooterRowDef="['disclaimerNew','disclaimer']" class="example-second-footer-row" [ngClass]="isAddingNewItem ?'':'d-none'"></tr>
      </table>
    </div>

    <div>
      <p class="footerNote">For vended proprietray product contact vendor representative customer service.</p>
    </div>
  </div>

  <div class="SeedFulfillBtnSec">

    <div class="row d-flex align-items-center">
      <div class="col-8">
        <button mat-raised-button *ngIf="!readOnlyAccess" class="btns w140" (click)="saveOrder()" [style.display]="'inline-block'" [disabled]="isPlaceOrderDisable || readOnlyAccess">Place Order</button>
        <button mat-raised-button class="btns w140" color="primary" (click)="navigateTolandingProductLabel()">Cancel</button>
      </div>
      <div class="col-4 text-right">
        PRODUCT LABELS SELECTED <span class="dataCount">{{dataCount}}</span>
      </div>
    </div>
  </div>
</div>
